import { Capacitor } from '@capacitor/core';

if (typeof window !== 'undefined') {
  try {
    window.__CAP_IS_NATIVE__ = Capacitor.isNativePlatform();
  } catch {
    window.__CAP_IS_NATIVE__ = false;
  }
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './App.css';

window.addEventListener('error', e => {
  console.error('❌ Window Error:', e.message, e.error);
});
window.addEventListener('unhandledrejection', e => {
  console.error('⚠️ Unhandled Promise Rejection:', e.reason);
});
console.log('✅ App JS loaded - debug logger active');


ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
                <App />
        </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(err => console.warn('SW registration failed:', err));
  });
}